<template>
  <van-tabbar
    v-model="active"
    active-color="#b57e48"
    inactive-color="#454976"
    :route="true"
    @change="onChange"
  >
    <van-tabbar-item icon="wap-home" to="">首页</van-tabbar-item>
    <van-tabbar-item icon="video" to="/home/index">学习</van-tabbar-item>
    <van-tabbar-item icon="manager" to="">我</van-tabbar-item>
  </van-tabbar>
</template>
<script>
  import store from '@/store'
  export default {
    data() {
      return {
        active: parseInt(this.$route.query.active) || 0,
      }
    },
    created() {},
    methods: {
      async init() {},
      async onChange(val) {
        const H5Url = await store.getters['system/getH5Url']
        if (val === 0) {
          const url = `${H5Url}case/#/home/index`
          window.location.href = url
        }
        if (val === 2) {
          const url = `${H5Url}case/#/home/ucenter`
          window.location.href = url
        }
        // this.$router.push(params)
      },
    },
  }
</script>
